import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const getHomePath = (role) => {
  if (role === "investor") return "/investor";
  if (role === "analyst") return "/analyst";
  if (role === "admin") return "/admin";
  return "/trader";
};

const ImpersonatePage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    const adminToken = params.get("admin");
    if (!token) { navigate("/login"); return; }

    fetch("/api/auth/impersonate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.access_token) {
          if (adminToken) localStorage.setItem("impersonate_admin_token", adminToken);
          localStorage.setItem("impersonate_as_email", data.email);
          localStorage.setItem("user_role", data.role || "analyst");
          localStorage.setItem("is_admin", data.role === "admin" ? "true" : "false");
          localStorage.setItem("access_token", data.access_token);
          localStorage.removeItem("token");
          // Redirect sesuai role
          navigate(getHomePath(data.role));
        } else {
          alert("Invalid or expired token");
          navigate("/login");
        }
      })
      .catch(() => { alert("Failed"); navigate("/login"); });
  }, []);

  return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center",
      height:"100vh", background:"var(--bg)", color:"var(--text-main)", fontSize:16 }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:32, marginBottom:16 }}>⏳</div>
        <div>Logging in as user...</div>
      </div>
    </div>
  );
};

export default ImpersonatePage;
